import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { toContractingParams } from "@/lib/contracting-params";
import { dashboardKeys } from "@/lib/query-keys";
import type { ContractingFilters, DashboardData } from "@/types/domain";

export function useDashboardData(filters: ContractingFilters, enabled = true) {
  return useQuery({
    queryKey: dashboardKeys.data(filters),
    enabled: enabled && filters.searchProfileId != null,
    staleTime: 30_000,
    // Como la lista: al cambiar un filtro se queda lo anterior (en gris) y no el esqueleto.
    placeholderData: keepPreviousData,
    queryFn: async () => {
      // The dashboard endpoint ignores pagination/sort params.
      const { page, size, sortBy, sortOrder, ...rest } = filters;
      const query = buildQuery(toContractingParams(rest));
      const res = await fetchToBackend<any>(
        `/dashboard/getDashboardData${query}`,
      );
      return (res?.data ?? res) as DashboardData;
    },
  });
}
